import { useToast } from 'primevue/usetoast'

type UseToastPrototype = ReturnType<typeof useToast>
const toastAddFn = (useToast.prototype as UseToastPrototype).add
export type ToastAddParams = Parameters<typeof toastAddFn>[0]
